/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { PaginatedEpsiDocListResponse } from '../types/PaginatedEpsiDocList';
import type { DmvsSource } from '../types/DmvsSource';

import type { UseResource } from '../../hooks/useResource';
import { useResource } from '../../hooks/useResource';

export type EpsiDocsListRequest = {} | null | undefined;
export type EpsiDocsListResponse = PaginatedEpsiDocListResponse;

export type EpsiDocsListQuery = {
  /**
   * ```yaml
   * in: query
   * name: dmvs_source
   * schema:
   *   type: string
   *   enum:
   *     - R46SynchronizaceStavova
   *     - R46SynchronizaceZmenova
   * description: |-
   *   * `R46SynchronizaceStavova` - R46 synchronizace PSPI stavová
   *   * `R46SynchronizaceZmenova` - R46 synchronizace PSPI změnová
   * ```
   */
  dmvs_source?: 'R46SynchronizaceStavova' | 'R46SynchronizaceZmenova';

  /**
   * ```yaml
   * in: query
   * name: dmvs_source__in
   * schema:
   *   type: array
   *   items:
   *     type: string
   *     enum:
   *       - R46SynchronizaceStavova
   *       - R46SynchronizaceZmenova
   * description: |-
   *   * `R46SynchronizaceStavova` - R46 synchronizace PSPI stavová
   *   * `R46SynchronizaceZmenova` - R46 synchronizace PSPI změnová
   * explode: true
   * style: form
   * ```
   */
  dmvs_source__in?: DmvsSource[];

  /**
   * ```yaml
   * name: page
   * required: false
   * in: query
   * description: A page number within the paginated result set.
   * schema:
   *   type: integer
   * ```
   */
  page?: number;

  /**
   * ```yaml
   * name: page_size
   * required: false
   * in: query
   * description: Number of results to return per page.
   * schema:
   *   type: integer
   * ```
   */
  page_size?: number;

  /**
   * ```yaml
   * in: query
   * name: pspi_datum_od
   * schema:
   *   type: string
   *   format: date
   * ```
   */
  pspi_datum_od?: string;

  /**
   * ```yaml
   * in: query
   * name: pspi_datum_od__gte
   * schema:
   *   type: string
   *   format: date
   * ```
   */
  pspi_datum_od__gte?: string;

  /**
   * ```yaml
   * in: query
   * name: pspi_datum_od__lte
   * schema:
   *   type: string
   *   format: date
   * ```
   */
  pspi_datum_od__lte?: string;

  /**
   * ```yaml
   * in: query
   * name: state
   * schema:
   *   type: string
   *   enum:
   *     - DOWNLOADING
   *     - DOWNLOAD_FAILED
   *     - IMPORTED
   *     - IMPORTING
   *     - IMPORT_FAILED
   *     - WAITING_FOR_DOWNLOAD
   *     - WAITING_FOR_IMPORT
   * description: |-
   *   * `WAITING_FOR_DOWNLOAD` - WAITING_FOR_DOWNLOAD
   *   * `DOWNLOADING` - DOWNLOADING
   *   * `DOWNLOAD_FAILED` - DOWNLOAD_FAILED
   *   * `WAITING_FOR_IMPORT` - WAITING_FOR_IMPORT
   *   * `IMPORTING` - IMPORTING
   *   * `IMPORT_FAILED` - IMPORT_FAILED
   *   * `IMPORTED` - IMPORTED
   * ```
   */
  state?:
    | 'DOWNLOADING'
    | 'DOWNLOAD_FAILED'
    | 'IMPORTED'
    | 'IMPORTING'
    | 'IMPORT_FAILED'
    | 'WAITING_FOR_DOWNLOAD'
    | 'WAITING_FOR_IMPORT';

  /**
   * ```yaml
   * in: query
   * name: state__in
   * schema:
   *   type: array
   *   items:
   *     type: string
   *     enum:
   *       - DOWNLOADING
   *       - DOWNLOAD_FAILED
   *       - IMPORTED
   *       - IMPORTING
   *       - IMPORT_FAILED
   *       - WAITING_FOR_DOWNLOAD
   *       - WAITING_FOR_IMPORT
   * description: |-
   *   * `WAITING_FOR_DOWNLOAD` - WAITING_FOR_DOWNLOAD
   *   * `DOWNLOADING` - DOWNLOADING
   *   * `DOWNLOAD_FAILED` - DOWNLOAD_FAILED
   *   * `WAITING_FOR_IMPORT` - WAITING_FOR_IMPORT
   *   * `IMPORTING` - IMPORTING
   *   * `IMPORT_FAILED` - IMPORT_FAILED
   *   * `IMPORTED` - IMPORTED
   * explode: true
   * style: form
   * ```
   */
  state__in?: (
    | 'DOWNLOADING'
    | 'DOWNLOAD_FAILED'
    | 'IMPORTED'
    | 'IMPORTING'
    | 'IMPORT_FAILED'
    | 'WAITING_FOR_DOWNLOAD'
    | 'WAITING_FOR_IMPORT'
  )[];
};

/**
 * GET /dmx-server/epsi_docs/
 *
 * ```yaml
 * operationId: epsi_docs_list
 * tags:
 *   - epsi_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PaginatedEpsiDocList'
 *     description: ''
 * ```
 */
export const epsiDocsListOperation = (rest?: EpsiDocsListQuery | null) =>
  ({
    method: 'GET',
    path: `/dmx-server/epsi_docs/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'GET';
    path: string & { _templateUrl: '/dmx-server/epsi_docs/' };
  };

/**
 * GET /dmx-server/epsi_docs/
 *
 * ```yaml
 * operationId: epsi_docs_list
 * tags:
 *   - epsi_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PaginatedEpsiDocList'
 *     description: ''
 * ```
 */
export const epsiDocsList = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query?: EpsiDocsListQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<PaginatedEpsiDocListResponse>> => {
  const operation = epsiDocsListOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'GET',
    request,
    onUploadProgress,
    cancelToken,
  );
};

/**
 * GET /dmx-server/epsi_docs/
 */
export const useEpsiDocsListResource = (
  query: EpsiDocsListQuery | null,
  useCached?: boolean,
): UseResource<EpsiDocsListResponse> => {
  return useResource<EpsiDocsListResponse>({
    path: query === null ? null : epsiDocsListOperation(query).path,
    apiUrl: globalThis.DMX_CONFIG.server,
    useCached,
  });
};
